import { cloneDeep } from 'external/lodash'
import { defaultRanges, DefaultRanges } from 'external/moment'
import {React, FC, useContext} from 'external/react'

import { TeacherContext } from 'teacher/context'
import { savePlan } from 'context/post'

import StyledTopbarButton from './StyledTopbarButton'

type SavePlanProps = {
  canSave?: boolean
  templateId?: string
}

const SavePlan:FC<Partial<typeof StyledTopbarButton> & SavePlanProps> = (props) => {
  const {canSave = true, templateId} = props
  const {translate, navigate, page, newPlan, newPlanFrom, newPlanFromQuery} = useContext(TeacherContext) as any
  return (
    <StyledTopbarButton
      variant="contained"
      disabled={canSave ? undefined : true}
      onClick={ async () => {
        const planToSave = cloneDeep(newPlan)
        planToSave.content = planToSave.content || {}
        planToSave.content.source = page
        await savePlan(planToSave, templateId)
        const query = {...newPlanFromQuery, ...defaultRanges[newPlanFrom as DefaultRanges](planToSave.start)}
        navigate({view: newPlanFrom}, '/:languageId/:role/:page/:view', {query})
      }}
    >
      {translate("save-plan-label")}
    </StyledTopbarButton>
  )
}

export {SavePlan as default}